<template>
    <div>
        <div class="card">
            <div class="card-body">
                <h5 class="mb-4">DataTable Panel Test</h5>
                <div class="d-flex gap-2 flex-wrap">
                    <button class="btn btn-primary btn-sm" @click="openBasic">Temel Tablo</button>
                    <button class="btn btn-info btn-sm" @click="openEditable">Düzenlenebilir</button>
                    <button class="btn btn-success btn-sm" @click="openExpandable">Expand + Sidebar Filtre</button>
                    <button class="btn btn-warning btn-sm" @click="openPaginated">Sayfalı</button>
                    <button class="btn btn-danger btn-sm" @click="openInlineActions">Inline Actions</button>
                    <button class="btn btn-sm" style="background:#8B5CF6;border-color:#8B5CF6;color:#fff" @click="openCustomRender">Custom Render</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dataTableService from '@/components/datatable/dataTableService'

const CITIES = ['İstanbul', 'Ankara', 'İzmir', 'Bursa', 'Antalya', 'Adana', 'Konya', 'Gaziantep', 'Mersin', 'Kayseri', 'Eskişehir', 'Samsun', 'Trabzon', 'Denizli', 'Malatya']
const STATUSES = ['Aktif', 'Pasif', 'Beklemede', 'İptal']
const NAMES = ['Ali Yılmaz', 'Ayşe Demir', 'Mehmet Kaya', 'Fatma Çelik', 'Ahmet Şahin', 'Zeynep Arslan', 'Mustafa Doğan', 'Elif Aydın', 'Hasan Yıldız', 'Merve Öztürk', 'Emre Koç', 'Büşra Aksoy', 'Can Erdoğan', 'Selin Korkmaz', 'Oğuz Özkan']

function generateRows(count, offset = 0) {
    return Array.from({ length: count }, (_, i) => {
        const idx = offset + i
        return {
            id: idx + 1,
            name: NAMES[idx % NAMES.length],
            email: NAMES[idx % NAMES.length].toLowerCase().replace(/\s/g, '.').replace(/[çÇğĞıİöÖşŞüÜ]/g, c => ({ ç: 'c', Ç: 'C', ğ: 'g', Ğ: 'G', ı: 'i', İ: 'I', ö: 'o', Ö: 'O', ş: 's', Ş: 'S', ü: 'u', Ü: 'U' }[c] || c)) + '@mail.com',
            city: CITIES[idx % CITIES.length],
            amount: Math.round(Math.random() * 50000 + 500),
            status: STATUSES[idx % STATUSES.length],
            date: new Date(2025, idx % 12, (idx % 28) + 1).toISOString().slice(0, 10),
            _readonly: idx === 3,
            _selectable: idx !== 5,
        }
    })
}

const ALL_ROWS = generateRows(100)

function filterRows(rows, filters) {
    return rows.filter(row => {
        for (const [key, val] of Object.entries(filters)) {
            if (!val) continue
            if (key === 'search') {
                const q = val.toLowerCase()
                if (!row.name.toLowerCase().includes(q) && !row.email.toLowerCase().includes(q)) return false
            } else if (key === 'status') {
                if (row.status !== val) return false
            } else if (key === 'city') {
                if (row.city !== val) return false
            } else if (key === 'dateRange' && typeof val === 'object') {
                if (val.from && row.date < val.from) return false
                if (val.to && row.date > val.to) return false
            }
        }
        return true
    })
}

const BASE_COLUMNS = [
    { key: 'id', label: '#', width: 50, sortable: true, align: 'center', priority: 'essential' },
    { key: 'name', label: 'Ad Soyad', sortable: true, editable: true, minWidth: 100, priority: 'essential' },
    { key: 'email', label: 'E-posta', sortable: true, minWidth: 100, priority: 'optional' },
    { key: 'city', label: 'Şehir', width: 110, sortable: true, priority: 'visible' },
    { key: 'amount', label: 'Tutar', width: 110, sortable: true, align: 'right', format: 'currency', priority: 'essential' },
    { key: 'status', label: 'Durum', width: 100, format: 'badge', priority: 'essential', color: (val) => {
        if (val === 'Aktif') return '#22C55E'
        if (val === 'Pasif') return '#EF4444'
        if (val === 'Beklemede') return '#F59E0B'
        return '#6B7280'
    }},
    { key: 'date', label: 'Tarih', width: 110, sortable: true, format: 'date', priority: 'optional' },
]

export default {
    name: 'TestDataTable',
    methods: {
        openBasic() {
            dataTableService.open({
                title: 'Müşteri Listesi',
                icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
                columns: BASE_COLUMNS,
                rows: [...ALL_ROWS],
                rowKey: 'id',
                totalCount: 100,
                selectable: true,
                editable: false,
                exportable: true,
                actions: [
                    { key: 'edit', label: 'Düzenle', icon: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>' },
                    { key: 'delete', label: 'Sil', icon: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>', danger: true },
                ],
                bulkActions: [
                    { key: 'delete', label: 'Seçilenleri Sil', icon: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>', danger: true },
                ],
                filters: [
                    { key: 'search', type: 'text', label: 'Ara', placeholder: 'İsim veya e-posta ara...' },
                    { key: 'status', type: 'select', label: 'Durum', options: STATUSES.map(s => ({ label: s, value: s })) },
                ],
                onRowAction(key, row) { console.log('onRowAction:', key, row) },
                onBulkAction(key, rows) { console.log('onBulkAction:', key, rows.length, 'rows') },
                onSort(col, dir) { console.log('onSort:', col, dir) },
                onFilter(vals) {
                    dataTableService.setLoading(true)
                    setTimeout(() => {
                        const filtered = filterRows(ALL_ROWS, vals)
                        dataTableService.setRows(filtered)
                        dataTableService.setLoading(false)
                    }, 400)
                },
                onRowClick(row) { console.log('onRowClick:', row) },
                onSelectionChange(rows) { console.log('onSelectionChange:', rows.length) },
                onClose() { console.log('onClose') },
            })
        },

        openEditable() {
            const rows = generateRows(30)
            dataTableService.open({
                title: 'Düzenlenebilir Tablo',
                icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></svg>',
                columns: BASE_COLUMNS.map(c => ({ ...c, editable: ['name', 'email', 'city'].includes(c.key) })),
                rows,
                rowKey: 'id',
                selectable: true,
                editable: true,
                filters: [
                    { key: 'search', type: 'text', label: 'Ara', placeholder: 'Ara...' },
                ],
                onEdit(row, col, newVal, oldVal) { console.log('onEdit:', row.id, col, oldVal, '->', newVal) },
                onFilter(vals) {
                    dataTableService.setLoading(true)
                    setTimeout(() => {
                        const filtered = filterRows(rows, vals)
                        dataTableService.setRows(filtered)
                        dataTableService.setLoading(false)
                    }, 400)
                },
            })
        },

        openExpandable() {
            const rows = generateRows(50)
            dataTableService.open({
                title: 'Detaylı Görünüm',
                icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>',
                columns: BASE_COLUMNS,
                rows,
                rowKey: 'id',
                selectable: true,
                expandable: true,
                filterLayout: 'sidebar',
                filters: [
                    { key: 'search', type: 'text', label: 'Ara', placeholder: 'Ara...' },
                    { key: 'city', type: 'select', label: 'Şehir', options: CITIES.slice(0, 8).map(c => ({ label: c, value: c })) },
                    { key: 'dateRange', type: 'daterange', label: 'Tarih Aralığı' },
                ],
                renderExpand: (row) => `<div><strong>${row.name}</strong> - ${row.city}<br/>E-posta: ${row.email}<br/>Tutar: ${row.amount.toLocaleString('tr-TR')}₺<br/>Kayıt Tarihi: ${row.date}</div>`,
                onFilter(vals) {
                    dataTableService.setLoading(true)
                    setTimeout(() => {
                        const filtered = filterRows(rows, vals)
                        dataTableService.setRows(filtered)
                        dataTableService.setLoading(false)
                    }, 400)
                },
                onRowClick(row) { console.log('expand row clicked:', row.id) },
            })
        },

        openPaginated() {
            const allRows = generateRows(250)
            const pageSize = 25
            dataTableService.open({
                title: 'Sayfalı Liste',
                icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>',
                columns: BASE_COLUMNS,
                rows: allRows.slice(0, pageSize),
                rowKey: 'id',
                totalCount: 250,
                pagination: 'paged',
                pageLimit: pageSize,
                selectable: true,
                filters: [
                    { key: 'search', type: 'text', label: 'Ara', placeholder: 'Ara...' },
                ],
                async onPageChange(page) {
                    await new Promise(r => setTimeout(r, 500))
                    const start = (page - 1) * pageSize
                    const pageRows = allRows.slice(start, start + pageSize)
                    dataTableService.setRows(pageRows)
                },
                onFilter(vals) {
                    dataTableService.setLoading(true)
                    setTimeout(() => {
                        const filtered = filterRows(allRows, vals)
                        dataTableService.setRows(filtered.slice(0, pageSize))
                        if (dataTableService.state.config) {
                            dataTableService.state.config.totalCount = filtered.length
                        }
                        dataTableService.setLoading(false)
                    }, 400)
                },
            })
        },

        openCustomRender() {
            const rows = generateRows(30)
            dataTableService.open({
                title: 'Özel Hücre Tasarımı',
                icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>',
                columns: [
                    { key: 'id', label: '#', width: 50, align: 'center', priority: 'essential' },
                    { key: 'name', label: 'Kullanıcı', sortable: true, minWidth: 180, priority: 'essential',
                        render: (val, row) => `<div style="display:flex;align-items:center;gap:10px"><div style="width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,#6366F1,#8B5CF6);display:flex;align-items:center;justify-content:center;color:#fff;font-weight:600;font-size:12px;flex-shrink:0">${val.charAt(0)}</div><div><div style="font-weight:500;font-size:13px">${val}</div><div style="font-size:11px;opacity:0.5">${row.email}</div></div></div>`
                    },
                    { key: 'city', label: 'Şehir', width: 120, sortable: true, priority: 'visible',
                        render: (val) => `<span style="display:inline-flex;align-items:center;gap:5px"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="opacity:0.4"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>${val}</span>`
                    },
                    { key: 'amount', label: 'Tutar', width: 140, sortable: true, align: 'right', priority: 'essential',
                        render: (val) => {
                            const pct = Math.min(100, Math.round(val / 500))
                            const color = pct > 70 ? '#22C55E' : pct > 40 ? '#F59E0B' : '#6B7280'
                            return `<div style="display:flex;flex-direction:column;gap:3px;width:100%"><span style="font-weight:500;font-size:13px;text-align:right">${Number(val).toLocaleString('tr-TR')}₺</span><div style="height:3px;border-radius:2px;background:rgba(128,128,128,0.12);width:100%"><div style="height:100%;border-radius:2px;background:${color};width:${pct}%"></div></div></div>`
                        }
                    },
                    { key: 'status', label: 'Durum', width: 120, sortable: true, priority: 'essential',
                        render: (val) => {
                            const colors = { Aktif: '#22C55E', Pasif: '#EF4444', Beklemede: '#F59E0B', İptal: '#6B7280' }
                            const c = colors[val] || '#6B7280'
                            return `<span style="display:inline-flex;align-items:center;gap:6px"><span style="width:7px;height:7px;border-radius:50%;background:${c};flex-shrink:0"></span><span style="font-size:13px">${val}</span></span>`
                        }
                    },
                    { key: 'date', label: 'Tarih', width: 110, sortable: true, format: 'date', priority: 'optional' },
                ],
                rows,
                rowKey: 'id',
                selectable: true,
                onRowClick(row) { console.log('custom render row clicked:', row.id) },
            })
        },

        openInlineActions() {
            dataTableService.open({
                title: 'Inline Aksiyonlar',
                icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>',
                columns: BASE_COLUMNS,
                rows: generateRows(40),
                rowKey: 'id',
                selectable: false,
                actionStyle: 'inline',
                actions: [
                    { key: 'edit', label: 'Düzenle', icon: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>' },
                    { key: 'delete', label: 'Sil', icon: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>', danger: true },
                ],
                onRowAction(key, row) { alert('Aksiyon: ' + key + '\nID: ' + row.id + '\nAd: ' + row.name + '\nE-posta: ' + row.email) },
            })
        },
    },
}
</script>
